import create from 'zustand'
import { AdoptersClient } from '../interactors/clients/AdoptersClient'
import { AdopterWithAnimalsReducedDto } from '../interactors/gen/backendClient'

interface AdoptersStore {
  adopters: AdopterWithAnimalsReducedDto[]
  fetchAdopters: () => Promise<void>
  fetchMoreAdopters: () => Promise<void>
  fetchOrRefreshAdopters: () => Promise<void>
  initializeAdoptersIfNeeded: () => Promise<void>
  refreshAdopters: () => Promise<void>
  isLoading: boolean
  areAdoptersInitialized: boolean
}

export const useAdoptersStore = create<AdoptersStore>()((set, get) => ({
  isLoading: false,
  adopters: [],
  fetchAdopters: async () => {
    set({ isLoading: true })

    const adoptersFetched = await AdoptersClient.getAllAdopters()
    set({ adopters: adoptersFetched })
    set({ isLoading: false })
    set({ areAdoptersInitialized: true })
  },
  refreshAdopters: async () => {
    const refreshedAdopters = await AdoptersClient.getAllAdopters()
    set({ adopters: refreshedAdopters })
  },
  fetchMoreAdopters: async () => {
    const adoptersFetched = await AdoptersClient.getAllAdopters({ page: get().adopters.length / 10 + 1, pageSize: 10 })
    set({ adopters: [...get().adopters, ...adoptersFetched] })
  },
  fetchOrRefreshAdopters: async () => {
    if (get().areAdoptersInitialized) {
      await get().refreshAdopters()
    } else {
      await get().fetchAdopters()
    }
  },
  initializeAdoptersIfNeeded: async () => {
    if (!get().areAdoptersInitialized) {
      console.log('Loading adopters')
      await get().fetchAdopters()
      console.log('Adopters loaded')
    }
  },
  areAdoptersInitialized: false,
}))
